<!-- カードのボディー -->
<div class="mail position-relative clearfix" style="padding-bottom:30px;">

  <div class="mail_body-textarea">
    <div *ngIf="rejectReason&&!rejectReason['fulltext_search']" class="keyword-reject">
      検索されたキーワードがヒットしませんでした
    </div>
    <div class="tag-area">
      <app-tag-button *ngFor="let tag of mailInfo.mail_custom_tags"
                      [tagName]="tag.tag_name">
      </app-tag-button>
    </div>
    <!-- 「全文を表示」部分にクリックイベントを追加 -->
    <div *ngIf="!mailInfo.showOtherThanImportantLine" class="show-full-text-button" >
      <span (click)="changeShowOnlyImportantLine(mailInfo)" class="link">全文を表示</span>
    </div>
    <div class="mail-body padding-top-30" [innerHTML]="
          mailInfo
            | setBodyString: mailInfo.keywords: baseKeywords
            | leaveOnlyImportantLine: mailInfo: !mailInfo.showOtherThanImportantLine && !!mailInfo.important_line_judge
            | changeStringToHyperLink
            | deEmphasizeNonMainpart: mailInfo: !!mailInfo.showOtherThanImportantLine && !!mailInfo.important_line_judge
            | highlightSearchedKeyword: searchParams
        ">
    </div>
    <!-- 「全文を表示」部分にクリックイベントを追加 -->
    <div *ngIf="!mailInfo.showOtherThanImportantLine" class="show-full-text-button" >
      <span (click)="changeShowOnlyImportantLine(mailInfo)" class="link">全文を表示</span>
    </div>
  </div>

  <div class="clearfix">
    <app-other-candidate-button *ngIf="pairMail" [workerMail]="workerMail" [projectMail]="projectMail"
      [baseMailType]="baseMailType">
    </app-other-candidate-button>
  </div>
  <div class="ai_mail_id">{{ mailInfo.ai_mail_id }}</div>
</div>